const ToolsFooter = () => {
  return (
    <>
      <footer id="footer">
        <div className="container tools__footer pt-4">
          <div className="row">
            <div className="d-flex justify-content-center">
              <p>
                <a href="https://www.fhnw.ch" target="_blank">
                  www.fhnw.ch
                </a>
                <span className="d-inline-block mx-1 mx-md-2">|</span>
                <a href="#">Impressum</a>
                <span className="d-inline-block mx-1 mx-md-2">|</span>
                <a href="#">Datenschutz</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ToolsFooter;
